var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseLayout',{attrs:{"panels":_vm.panels,"gutter":20,"padding":20}})
}
var staticRenderFns = []

export { render, staticRenderFns }